import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[disableDragndrop]'
})
export class DisableDragndropDirective {

  constructor(private _elementRef: ElementRef) { }


  @HostListener('document:dragover', ['$event'])
  @HostListener('document:drop', ['$event'])
  ondragOver(event:any) {
    event.preventDefault();
    return false;
  }
}
